import { render } from "./RegisterButtons.vue?vue&type=template&id=197aa938&scoped=true"
import script from "./RegisterButtons.vue?vue&type=script&lang=js"
export * from "./RegisterButtons.vue?vue&type=script&lang=js"

import "./RegisterButtons.vue?vue&type=style&index=0&id=197aa938&scoped=true&lang=css"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197aa938"]])

export default __exports__